import { render, staticRenderFns } from "./FactureInterfaceTemplate.vue?vue&type=template&id=c8cbab14&scoped=true&"
import script from "./FactureInterfaceTemplate.vue?vue&type=script&lang=js&"
export * from "./FactureInterfaceTemplate.vue?vue&type=script&lang=js&"
import style0 from "./FactureInterfaceTemplate.vue?vue&type=style&index=0&id=c8cbab14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8cbab14",
  null
  
)

export default component.exports